import { Link } from "react-router-dom";
import { ArrowUpRight, Home as HomeIcon } from "lucide-react";
import { useReveal } from "../lib/useReveal";

export default function SisterProject() {
  const ref = useReveal();
  return (
    <section
      id="apan-ghar-card"
      data-testid="sister-project-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal">
          <Link
            to="/apan-ghar"
            data-testid="apan-ghar-cta-link"
            className="group block relative overflow-hidden rounded-3xl border border-[#E3DECE] bg-gradient-to-br from-[#FAF4E8] via-[#F5EAD3] to-[#E8D5B7] p-10 md:p-16 hover:-translate-y-1 transition-all duration-700 hover:shadow-[0_30px_60px_-30px_rgba(92,58,31,0.45)]"
          >
            {/* Decorative rings */}
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full border border-[#5C3A1F]/15 pointer-events-none" />
            <div className="absolute -top-10 -right-10 w-56 h-56 rounded-full border border-[#5C3A1F]/20 pointer-events-none" />
            <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full border border-[#C9A66B]/30 pointer-events-none" />

            <div className="relative grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-8">
                <div className="flex items-center gap-3 mb-5">
                  <span className="h-[1px] w-10 bg-[#5C3A1F]" />
                  <span className="text-[10px] tracking-[0.32em] uppercase text-[#5C3A1F] font-semibold">
                    Our Sister Project
                  </span>
                </div>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2D1810] leading-[1.05]">
                  Apna Ghar — <span className="italic text-[#5C3A1F]">a home</span> for forgotten hearts.
                </h2>
                <p className="mt-6 text-[#5C4A3A] text-lg leading-relaxed max-w-2xl">
                  Where mentally ill individuals and people disowned by their
                  families find shelter, dignity and a family again. Run by the
                  same Bokadia trust — with the same promise, in a different home.
                </p>

                <div className="mt-8 inline-flex items-center gap-3 text-[#5C3A1F] font-semibold border-b border-[#5C3A1F] pb-1 group-hover:gap-5 transition-all">
                  Step inside Apna Ghar
                  <ArrowUpRight className="w-5 h-5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
                </div>
              </div>

              <div className="lg:col-span-4 relative">
                <div className="relative aspect-square rounded-2xl bg-[#5C3A1F] flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-0 opacity-25 mix-blend-overlay"
                    style={{
                      backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence baseFrequency='0.85' numOctaves='2' /></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
                    }}
                  />
                  <div className="text-center relative">
                    <HomeIcon className="w-12 h-12 mx-auto text-[#C9A66B]" strokeWidth={1.4} />
                    <div className="font-display text-[#FAF4E8] text-5xl mt-4 italic">
                      Apna
                    </div>
                    <div className="font-display text-[#C9A66B] text-5xl italic -mt-2">
                      Ghar
                    </div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-[#FAF4E8]/70 mt-4">
                      Our Home
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
